<template>
  <div class="all-results-wrapper-mobile min-h-[100vh]">
    <AllResultsComponentMobile />
  </div>
</template>

<script>
import AllResultsComponentMobile from '@/components/mobile/AllResultsComponent.vue';

export default {
  name: 'AllResultsWrapperMobile',
  components: {
    AllResultsComponentMobile,
  },
};
</script>

<style scoped>
.all-results-wrapper-mobile {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 10px;
  min-height: calc(100vh - 180px);
  box-sizing: border-box;
}
</style>
